import { cloneElement, isValidElement, ReactElement } from 'react';

import { HeaderIconProps, HeaderIconSize } from '../common';

const HEADER_ICON_FONT_SIZE_MAP: Partial<Record<HeaderIconSize, number>> = {
  [HeaderIconSize.Size56]: 32,
  [HeaderIconSize.Size48]: 24,
  [HeaderIconSize.Size40]: 24,
  [HeaderIconSize.Size36]: 20,
  [HeaderIconSize.Size32]: 16,
};

const HEADER_ICON_STROKE_WIDTH_MAP: Partial<Record<HeaderIconSize, number>> = {
  [HeaderIconSize.Size56]: 2,
  [HeaderIconSize.Size48]: 1.5,
  [HeaderIconSize.Size40]: 1.5,
  [HeaderIconSize.Size36]: 1,
  [HeaderIconSize.Size32]: 1,
};

type UseModalHeaderIconArgs = Pick<HeaderIconProps, 'icon' | 'size'>;

export function useModalHeaderIcon({ icon, size }: UseModalHeaderIconArgs) {
  const sizeClassName = size ? `header-icon--size-${size}` : '';
  if (!icon || !size || !isValidElement(icon)) return { iconNode: icon, sizeClassName };

  const iconFontSize = HEADER_ICON_FONT_SIZE_MAP[size];
  const iconStrokeWidth = HEADER_ICON_STROKE_WIDTH_MAP[size];

  const iconNode = cloneElement(
    icon as ReactElement<{ fontSize?: number; strokeWidth?: number }>,
    {
      ...(iconFontSize ? { fontSize: iconFontSize } : {}),
      ...(iconStrokeWidth ? { strokeWidth: iconStrokeWidth } : {}),
    },
  );

  return { iconNode, sizeClassName };
}
